import styled from '@emotion/styled';

export const WorkspaceListContainer = styled.div({
    maxHeight: '16rem',
    width: '100%',
    overflowY: 'auto',
});
